import { BodySm, H4 } from '@/components/ui/typography/Typography';
import { NavLink } from 'react-router-dom';

export default function ProdukSidebar({ items, title, basePath }) {
  return (
    <aside className="w-full lg:w-64 rounded-lg border px-4 py-4 lg:py-0 lg:px-4 mb-10 lg:rounded-none lg:border-0 lg:border-r border-gray-200 lg:pr-6">
      <H4 className="mb-2 lg:mb-4">{title}</H4>

      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.slug}>
            <NavLink
              to={`${basePath}/${item.slug}`}
              className={({ isActive }) =>
                `relative inline-block py-1 transition-all group
     ${isActive ? 'text-primary font-semibold' : 'text-gray-700 hover:text-primary hover:font-semibold'}`
              }
            >
              {({ isActive }) => (
                <>
                  <BodySm className="relative z-10 inline-block">{item.title}</BodySm>
                  <span
                    className={`absolute bottom-0 left-0 h-[4px] bg-yellow-300 rounded-sm transition-all duration-300 origin-left
          ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}
        `}
                    style={{ width: '100%' }}
                  ></span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </aside>
  );
}
